export const SITE_URL = 'https://shabimedia.com'

export const businessAreaServed = [
  { '@type': 'City', name: 'Madurai' },
  { '@type': 'City', name: 'Karaikudi' },
  { '@type': 'State', name: 'Tamil Nadu' },
]

export const businessAddress = {
  '@type': 'PostalAddress',
  addressLocality: 'Madurai',
  addressRegion: 'Tamil Nadu',
  addressCountry: 'IN',
}

export const businessOpeningHours = [
  {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '09:30',
    closes: '20:30',
  },
]